import { createContext, RefObject, useEffect, useRef, useState } from "react";
import { debounce } from "lodash";
import useResizeObserver from "use-resize-observer";

import { QuickRankRenderableDestinations } from "../../reducers/quickrank";

const { DECK, HAND, RATED } = QuickRankRenderableDestinations;

export type QuickRankDestinationsContextType = {
  refs: {
    [key in QuickRankRenderableDestinations]: {
      ref: RefObject<HTMLDivElement>;
      toRender: number;
    };
  };
  resizeClock: number;
};

export const QuickRankDesinationsContext = createContext<QuickRankDestinationsContextType | null>(null);

interface QuickRankDestinationsProviderProps {
  children: React.ReactNode;
  cardsInDeck: number;
  cardsPerHand: number;
}

export const QuickRankDestinationsProvider = (props: QuickRankDestinationsProviderProps) => {
  const { children, cardsInDeck, cardsPerHand } = props;

  const { ref: resizeObserverRef, width, height } = useResizeObserver<HTMLDivElement>();
  const [resizeClock, setResizeClock] = useState(0);
  const updateClock = debounce(() => setResizeClock((prev) => prev + 1), 200);

  const deckRef = useRef<HTMLDivElement>(null);
  const handRef = useRef<HTMLDivElement>(null);
  const ratedRef = useRef<HTMLDivElement>(null);

  useEffect(() => updateClock(), [width, height]);

  return (
    <QuickRankDesinationsContext.Provider
      value={{
        refs: {
          [DECK]: {
            ref: deckRef,
            toRender: cardsInDeck,
          },
          [HAND]: {
            ref: handRef,
            toRender: cardsPerHand,
          },
          [RATED]: {
            ref: ratedRef,
            toRender: 1,
          },
        },
        resizeClock,
      }}
    >
      <div
        ref={resizeObserverRef}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
        }}
      />
      {children}
    </QuickRankDesinationsContext.Provider>
  );
};
